/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_Mock_TitleInputs */

const en_cap_research_mock_title = /** @type {(inputs: Cap_Research_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief: veterinary clinics in the Baltics`)
};

const lv_cap_research_mock_title = /** @type {(inputs: Cap_Research_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopsavilkums: veterinārās klīnikas Baltijā`)
};

/**
* | output |
* | --- |
* | "Brief: veterinary clinics in the Baltics" |
*
* @param {Cap_Research_Mock_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_mock_title = /** @type {((inputs?: Cap_Research_Mock_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_Mock_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_mock_title(inputs)
	return en_cap_research_mock_title(inputs)
});